import styled from 'styled-components';

export default styled.div`
  color: ${({ isActive }) => (isActive ? '#f6fdff' : '#c5cede')};
  font-weight: ${({ isActive }) => (isActive ? 'bold' : 'normal')};
  font-size: 14px;
`;
